import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { propShape } from '../../../../helpers/custom-prop-types';
import Image from '../../../Ui/Common/Image';
const MyFavoriteBoardTabContentImage = (props) => {
    const { board } = props;
    const { clips } = board;
    const ranges = _.range(0, Math.min(clips.length, 4));
    return (_jsx("div", Object.assign({ className: `is-thumbnail board-image board-image-${ranges.length}` }, { children: ranges.map((v) => (_jsx("div", Object.assign({ className: 'board-image-box' }, { children: _jsx(Image, { allowContextMenu: false, alt: '', isObjectFit: true, src: clips[v].image }) }), v))) })));
};
MyFavoriteBoardTabContentImage.propTypes = {
    board: propShape().isRequired,
};
export default MyFavoriteBoardTabContentImage;
